export default function initSortService() {
  return function (paramName) {
    let key = ''
    let val = ''
    let orderMap = {}
    if (
      paramName &&
      sessionStorage[paramName] &&
      JSON.parse(sessionStorage[paramName]).orderMap
    ) {
      orderMap = JSON.parse(sessionStorage[paramName]).orderMap
      key = Object.keys(orderMap)[0]
      val = orderMap[key]
    }
    return {
      sortKey: key,
      sortVal: val,
    }
  }
}



// WEBPACK FOOTER //
// ./src/common/services/initSortService.js